import React, { Component } from "react";
import { AiOutlineAudit } from "react-icons/ai";
import CheckIcon from "app/Components/_checkIcon/CheckIcon";
import { GoStop } from "react-icons/go";
import { Link } from "react-router-dom";
import { classList } from "@utils";
import DropDownMenuItem from "./DropDownMenuItem";
import { Fragment } from "react";
import {
  SetGlobalPermission,
  SetPermission,
} from "app/Components/SetPermission/Permissions";

class DropDownMenu extends Component {
  state = {
    open: false,
  };

  onItemClick = (e) => {
    e.preventDefault();
    this.setState({ open: !this.state.open });
  };

  renderLevels = (items) =>
    items.map((item, i) => {
      if (item.sub) {
        return (
          <SetPermission
            permission={item.permission}
            data={
              <DropDownMenuItem key={i} item={item}>
                {this.renderLevels(item.sub)}
              </DropDownMenuItem>
            }
          ></SetPermission>
        );
      } else {
        // console.log("asdasd/*/*/*/*/*", item);
        return (
          <Fragment key={i}>
            {item && item.global == true ? (
              <SetGlobalPermission
                permission={
                  item.superAdmin == true
                    ? "superAdmin"
                    : item.permission
                    ? item.permission
                    : "global"
                }
                data={
                  <li
                    key={i}
                    className={classList({
                      "nav-item": true,
                      open: this.state.open,
                    })}
                    onClick={this.props.closeSecSidenav}
                  >
                    <Link to={item.path}>
                      {/* <i className={`nav-icon ${item.icon}`}></i> */}
                      <CheckIcon icon={item.icon} classIs="smallIcons" />
                      <span className="item-name">{item.name}</span>
                    </Link>
                  </li>
                }
              ></SetGlobalPermission>
            ) : item && item.permission ? (
              <SetPermission
                permission={item.permission}
                data={
                  <li
                    key={i}
                    className={classList({
                      "nav-item": true,
                      open: this.state.open,
                    })}
                    onClick={this.props.closeSecSidenav}
                  >
                    <Link to={item.path}>
                      {/* <i className={`nav-icon ${item.icon}`}></i> */}
                      <CheckIcon icon={item.icon} classIs="smallIcons" />
                      <span className="item-name">{item.name}</span>
                    </Link>
                  </li>
                }
              ></SetPermission>
            ) : (
              <li
                key={i}
                className={classList({
                  "nav-item": true,
                  open: this.state.open,
                })}
                onClick={this.props.closeSecSidenav}
              >
                <Link to={item.path}>
                  <CheckIcon icon={item.icon} classIs="smallIcons" />
                  {/* <i className={`nav-icon ${item.icon}`}></i> */}
                  <span className="item-name">{item.name}</span>
                </Link>
              </li>
            )}
          </Fragment>
        );
      }
    });

  render() {
    return <ul className="childNav">{this.renderLevels(this.props.menu)}</ul>;
  }
}

export default DropDownMenu;
